const editMode = {
  Disable: 0,
  Enable: 1,
  IfInsert: 2
};

export default editMode;
